import {isCountryAt} from '../utilities/country.mjs';

/**
 * Migrated from:
 * nm/mvc/ValidatedAddressMixin.js
 */

export const ValidatedAddressMixin = {
  address1Rule() {
    if (isCountryAt) {
      return ['street_at'];
    } else {
      return ['street_de'];
    }
  },

  zipRule() {
    if (isCountryAt) {
      return ['zip_at'];
    } else {
      return ['zip_de'];
    }
  },
};
